import { PortableTextProps } from '@portabletext/react'
import { MlNotificationProps, NotificationType } from '@studio/atomic-ui'
/**
 * Replace a text placeholder using the form [`variable_name`] with an actual value, the variable name is case-insensitive
 * @param text Block to search from
 * @param placeholder Variable name to replace
 * @param value Value to replace the placeholder with
 */
export const placeholder = (text: string, placeholder: string, value: string) =>
  text.replace(new RegExp(`\\[${placeholder}\\]`, 'i'), value)

/**
 * Basic block for a bullet item
 * @param text to add into the bullet
 * @param custom custom array of objects for greater customization of what's inside the bullet item (bold, italic, etc)
 */
export const listBulletBlock = (text: string, custom?: object[]) => ({
  _type: 'block',
  style: 'normal',
  markDefs: [],
  level: 1,
  listItem: 'bullet',
  children: text
    ? [
        {
          _type: 'span',
          marks: [],
          text,
        },
      ]
    : custom,
})

/** Find the position of block of rich text that contains the placeholder for modifications */
export const findBlockIdx = (block: { children: { text: string }[] }[], placeholder = '[error]') =>
  block.findIndex((b) => b.children.some((t) => t.text === placeholder))

export const replaceBlock = (block: object[], position: number, toInsert: object[]) => {
  const beginning = block.slice(0, position)
  const end = block.slice(position + 1, block.length)
  return [...beginning, ...toInsert, ...end]
}

/**
 * Get the current error messages as list bullets
 * @param fields - with errors
 * @param errorBlocks - array of error blocks for each field in the form
 */
export const prepareErrors = (fields: string[], errorBlocks?: { [p: string]: PortableTextProps['value'] }) =>
  fields.flatMap((field) => {
    if (!(errorBlocks && field in errorBlocks && errorBlocks[field])) return []
    return [listBulletBlock('', errorBlocks[field] as object[])]
  })

export const replaceTextInNotificationBody = (notification: MlNotificationProps, texts: string[]) => {
  const newBlocks = texts.map((text) => addblock(text))
  const errorBlock = addErrorMessage(texts)
  notification.body = [errorBlock, ...newBlocks]

  return notification
}

const addblock = (text: string) => {
  return {
    _type: 'block',
    children: [listBulletBlock(text)],
    markDefs: [],
    style: 'normal',
  }
}

const addErrorMessage = (texts: string[]) => {
  return {
    _type: 'block',
    style: 'normal',
    markDefs: [],
    children: [
      {
        _type: 'span',
        marks: [],
        text: texts.length > 1 ? 'Two or more errors found' : 'One (1) error found:',
      },
    ],
  }
}

export const customErrorSnackbarMessage = (text: string) => {
  return {
    buttonLabel: 'Dismiss',
    message: text,
    type: 'negative' as NotificationType,
  }
}
